export const mmTabData = [
  { id: "expert-review", label: "Expert opinion" },
  { id: "chat", label: "Chat" },
  { id: "specs", label: "Specs" },
  { id: "variants", label: "Variants" },
  { id: "comparison", label: "Comparison" },
];

export const mmTabDataForApp = [
  { id: "expert-review", label: "Expert opinion" },
  { id: "ask-sid", label: "Ask Sid" },
  { id: "variants", label: "Variants" },
  { id: "features", label: "Features" },
  { id: "specs", label: "Specs" },
  { id: "mm-colors-section", label: "Colours" },
  { id: "price", label: "Price" },
  { id: "mileage", label: "Mileage" },
  // { id: "dimensions", label: "Dimensions" },
  { id: "service-cost", label: "Service cost" },
  { id: "comparison", label: "Comparison" },
];
